import React, { FC } from "react";
import { Button, Row, Col } from "antd";
import { ReactSVG } from "react-svg";

const LocationItem: FC<{
  type: string;
  title: string;
  locationObj: any;
  address?: any;
}> = ({ type, title, locationObj, address }) => (
  <Row className="location-item d-flex">
    <Col>
      <Button className="beam-btn inbound icon-btn">
        <ReactSVG
          src="/images/geolocation-icon.svg"
          className={`${type}-icon`}
        />
      </Button>
    </Col>
    <Col span={20}>
      <h5>
        {title} - {address || locationObj?.attributes?.address}
      </h5>
      <p>
        Lat: {locationObj?.coordinates?.lat}, Long:{" "}
        {locationObj?.coordinates?.long}
      </p>
    </Col>
  </Row>
);

export default LocationItem;
